<template>
  <div class="export-content">
    <div class="export-content__title-wrapper">
      <h1 class="export-content__title">Export</h1>
      <div class="export-content__settings">
        <div class="export-content__integration-settings">
          <div class="export-content__buttons-wrapper">
            <div class="export-content__setting_buttons">
              <IntegrationButton
                name="readwise"
                description="Resurfacing your best highlights"
                :isSelected="selectedIntegration === 'Readwise'"
                :imageUrl="readwiseLogo"
                :darkImageUrl="readwiseLogoDark"
                :isEnabled="isReadwiseEnabled"
                @click="clickIntegrationButton('Readwise')"
              />
              <IntegrationButton
                name="notion"
                description="Workspace that adapts to your needs"
                :imageUrl="notionLogo"
                :darkImageUrl="notionLogoDark"
                :isEnabled="isNotionEnabled"
                :isSelected="selectedIntegration === 'Notion'"
                @click="clickIntegrationButton('Notion')"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <ReadwiseSettings
      v-show="selectedIntegration === 'Readwise'"
      :isReadwiseEnabled="isReadwiseEnabled"
      @updateEnabled="setReadwiseEnabled"
    />
    <NotionSettings
      v-show="selectedIntegration === 'Notion'"
      :isNotionEnabled="isNotionEnabled"
      @updateEnabled="setNotionEnabled"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import ReadwiseSettings from '@/app/components/export/ReadwiseSettings.vue'
import NotionSettings from '@/app/components/export/NotionSettings.vue'
import IntegrationButton from '@/app/components/export/IntegrationButton.vue'

import readwiseLogo from '@/assets.v2/images/readwise-logo.svg'
import readwiseLogoDark from '@/assets.v2/images/readwise-logo-dark.svg'
import notionLogo from '@/assets.v2/images/notion-logo.svg'
import notionLogoDark from '@/assets.v2/images/notion-logo-dark.svg'

const selectedIntegration = ref<string | null>(null)
const isReadwiseEnabled = ref(false)
const isNotionEnabled = ref(false)

function clickIntegrationButton(integration: string): void {
  selectedIntegration.value = integration
}

function setReadwiseEnabled(value: boolean): void {
  isReadwiseEnabled.value = value
}

function setNotionEnabled(value: boolean): void {
  isNotionEnabled.value = value
}
</script>
